export const config_base = {
	applicationSettings: {}, // general app settings
	theme: {}, // theme settings
	configurator: {
		steps: [
			{
				id: "shape",
				title: "Vorm",
				translationText: "menu.vorm",
				icon: "/icons/shape.svg",
				content: [
					{
						id: "shape",
						settings: {
							style: "ImageButton",
						},
					},
				],
			},
			{
				id: "tabletopMaterial",
				title: "Materiaal",
				translationText: "menu.materiaal",
				icon: "/icons/material.svg",
				content: [
					{
						id: "tableMaterial",
						settings: {
							style: "ImageButton",
						},
					},
					{
						id: "option",
						settings: {
							style: "TextButton",
						},
						data: {
							id: "brushed",
							translationText: "label.borstelen",
							storeProp: "brushed",
							values: [
								{ id: true, translationText: "option.borstelen" },
								{ id: false, translationText: "option.nietBorstelen" },
							],
							conditions: [
								{
									storeProp: "tableMaterial",
									checkValue: "oak",
								},
							],
						},
					},
				],
			},
			{
				id: "dimensions",
				title: "Specificaties",
				translationText: "menu.specificaties",
				icon: "/icons/specifications.svg",
				content: [
					{
						id: "dimension",
					},
					{
						id: "thickness",
						settings: {
							style: "TextButton",
						},
					},
					{
						id: "edge",
						settings: {
							style: "ImageButton",
						},
					},
				],
			},
			{
				id: "tableleg",
				title: "Tafelpoot",
				translationText: "menu.tafelpoot",
				icon: "/icons/table-leg.svg",
				content: [
					{
						id: "option",
						settings: {
							style: "TextButton",
						},
						data: {
							id: "legMaterial",
							title: "Materiaal",
							translationText: "label.materiaal",
							storeProp: "legMaterial",
							values: [
								{ id: "oak", translationText: "option.eik" },
								{ id: "steel", translationText: "option.staal" },
							],
						},
					},
					{
						id: "leg",
						settings: {
							style: "ImageButton",
						},
					},
					{ id: "legDistance" },
					{
						id: "legColors",
						settings: {
							style: "ImageButton",
						},
					},
				],
			},
			{
				id: "overview",
				title: "Overzicht",
				translationText: "menu.overzicht",
				icon: "/icons/summary.svg",
				content: [
					{
						id: "summary",
					},
					{
						id: "userform",
					},
				],
			},
			{
				id: "settings",
				title: "Settings",
				translationText: "menu.settings",
				icon: "/icons/settings.svg",
				content: [],
				link: "/dashboard",
			},
		],
		categories: [
			{
				id: "swing_gate",
				title: "Swing Gate",
				gates: ["swg_stockholm", "swg_san_francisco", "swg_tokyo", "swg_vienna", "swg_paris", "swg_new_york"],
			},
			// {
			// 	id: "sliding_gate",
			// 	title: "Sliding Gate",
			// 	gates: ["slg_hanoi"],
			// },
		],
		gates: [
			{
				id: "swg_stockholm",
				type: "gate",
				title: "Stockholm",
				icon: () => (
					<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512">
						<path d="M32,416c-17.7,0-32,14.3-32,32s14.3,32,32,32h128v-128c0-53,43-96,96-96s96,43,96,96v128h128c17.7,0,32-14.3,32-32s-14.3-32-32-32v-248H32v248Z" />
						<g>
							<path d="M503.8,122.6c-11,13.7-30.8,16-44.6,5.2h0s0,0,0,0h0c0,0,0,0,0,0t0,0h0s0,0,0,0c0,0,0,0,0,0h0c-.2-.1-.5-.4-1-.7-1.3-.9-3.5-2.3-6.9-4.2-6.7-3.8-17.8-9.2-33.8-14.7-32-11.1-84-23-161.2-23-56.9,0-99,5.6-129.5,12.6-30.5,7-49.3,15.5-59.8,21.4-7,3.9-10.3,6.7-11,7.3h-.1c0,.1-1.3-1.3-1.3-1.3l1.3,1.4c-12.3,12.1-32,12.3-44.5.3-12.8-12.2-13.2-32.5-1-45.2,2.5-2.6,12.4-12,33.3-22.5,20.9-10.5,52.7-22.1,99.1-29.6,31-5,68.4-8.3,113.6-8.3,83.8,0,143.2,12.9,182.3,26.5,39.1,13.6,57.9,27.9,60.5,30,13.8,11,16,31.2,5,45Z" />
							<polygon points="55.7 126.4 55.6 126.4 54.3 125 55.7 126.4" />
						</g>
					</svg>
				),
				materials: ["oak_whiteriver", "oak_light", "oak_brown"], //material id's
				shape: "arc",
				pillars: ["pillar_stockholm", "pillar_sanfrancisco"],
				dimensions: [
					{
						id: "center_height",
						title: "Center Height",
						minVal: 100,
						maxVal: 250,
						defaultVal: 190,
						step: 10,
						selectType: "range",
					},
					{
						id: "outer_height",
						title: "Outer Height",
						minVal: 100,
						maxVal: 250,
						defaultVal: 170,
						step: 10,
						selectType: "range",
					},
					{
						id: "door_width",
						title: "Door Width",
						minVal: 150,
						maxVal: 400,
						defaultVal: 150,
						step: 10,
						selectType: "range",
					},
					{
						id: "door_frame_width",
						title: "Door Frame Width",
						values: [10, 12, 15, 18],
						defaultVal: 12,
						selectType: "preset",
					},
					{
						id: "door_frame_thickness",
						title: "Door Frame Thickness",
						values: [5, 10, 15, 20],
						defaultVal: 10,
						selectType: "preset",
					},
					{
						id: "door_plank_width",
						title: "Door Plank Width",
						values: [5, 10, 12, 20],
						defaultVal: 20,
						selectType: "preset",
					},
				],
				selectedModifiers: [{ id: "crown", location: "beam_vertical_top" }],
				modifiers: ["crown"], //boolean
			},
			{
				id: "swg_san_francisco",
				type: "gate",
				title: "San Francisco",
				icon: () => (
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
						<path d="M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 64 0 0-128c0-53 43-96 96-96s96 43 96 96l0 128 64 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-288L32 128l0 288z" />
					</svg>
				),
				materials: ["light_metal", "heavy_metal"], //material id's
				shape: "straight",
				pillars: ["pillar_sanfrancisco"],
				dimensions: [
					{
						id: "center_height",
						title: "Center Height",
						minVal: 100,
						maxVal: 250,
						defaultVal: 190,
						step: 10,
						selectType: "range",
					},
					{
						id: "outer_height",
						title: "Outer Height",
						minVal: 100,
						maxVal: 250,
						defaultVal: 170,
						step: 10,
						selectType: "range",
					},
					{
						id: "door_width",
						title: "Door Width",
						minVal: 150,
						maxVal: 400,
						defaultVal: 150,
						step: 10,
						selectType: "range",
					},
					{
						id: "door_frame_width",
						title: "Door Frame Width",
						values: [10, 12, 15, 20],
						defaultVal: 12,
						selectType: "preset",
					},
					{
						id: "door_frame_thickness",
						title: "Door Frame Thickness",
						values: [5, 10, 15, 20],
						defaultVal: 10,
						selectType: "preset",
					},
					{
						id: "door_plank_width",
						title: "Door Plank Width",
						values: [5, 10, 12, 20],
						defaultVal: 20,
						selectType: "preset",
					},
				],
				modifiers: [],
			},
			// {
			// 	id: "swg_tokyo",
			// 	type: "gate",
			// 	title: "Tokyo",
			// 	icon: () => (
			// 		<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512">
			// 			<path d="M32,416c-17.7,0-32,14.3-32,32s14.3,32,32,32h128v-128c0-53,43-96,96-96s96,43,96,96v128h128c17.7,0,32-14.3,32-32s-14.3-32-32-32v-248H32v248Z" />
			// 			<path d="M33.2,137.9C15,137.9.2,123.1.2,104.9s14.8-33,33-33,22.4-10.8,33-18c22.2-15,47.4-32,78.1-32,27.1,0,50.3,15.7,70.9,29.6,14.2,9.6,30.2,20.4,40.2,20.4s23-10.7,34.5-18.5c21.9-14.8,46.7-31.5,76.6-31.5s51.1,15.9,71.9,29.9c13.9,9.4,29.7,20.1,39.3,20.1,18.2,0,33,14.8,33,33s-14.8,33-33,33c-29.7,0-54.4-16.7-76.2-31.4-11.6-7.9-27.6-18.6-34.9-18.6s-25.6,10.7-39.7,20.2c-20.7,14-44.1,29.8-71.4,29.8-30.2,0-55.2-16.9-77.2-31.7-11.4-7.7-27.1-18.3-33.9-18.3-10.5,0-26.8,11-41.2,20.7-20.3,13.7-43.3,29.3-69.9,29.3Z" />
			// 		</svg>
			// 	),
			// 	materials: ["oak_light"], //material id's
			// 	shape: "wave",
			// 	pillars: ["pillar_tokyo"],
			// 	dimensions: [
			// 		{
			// 			id: "center_height",
			// 			title: "Center Height",
			// 			minVal: 100,
			// 			maxVal: 250,
			// 			defaultVal: 190,
			// 			step: 10,
			// 			selectType: "range",
			// 		},
			// 		{
			// 			id: "outer_height",
			// 			title: "Outer Height",
			// 			minVal: 100,
			// 			maxVal: 250,
			// 			defaultVal: 170,
			// 			step: 10,
			// 			selectType: "range",
			// 		},
			// 		{
			// 			id: "door_width",
			// 			title: "Door Width",
			// 			minVal: 150,
			// 			maxVal: 400,
			// 			defaultVal: 150,
			// 			step: 10,
			// 			selectType: "range",
			// 		},
			// 		{
			// 			id: "door_frame_width",
			// 			title: "Door Frame Width",
			// 			values: [5, 10, 15, 20],
			// 			defaultVal: 10,
			// 			selectType: "preset",
			// 		},
			// 		{
			// 			id: "door_frame_thickness",
			// 			title: "Door Frame Thickness",
			// 			values: [5, 10, 15, 20],
			// 			defaultVal: 10,
			// 			selectType: "preset",
			// 		},
			// 		{
			// 			id: "door_plank_width",
			// 			title: "Door Plank Width",
			// 			values: [5, 10, 12, 20],
			// 			defaultVal: 20,
			// 			selectType: "preset",
			// 		},
			// 	],
			// 	modifiers: [],
			// },
			{
				id: "slg_hanoi",
				type: "gate",
				title: "Hanoi",
				materials: ["oak_light"], //material id's
				shape: "arc",
				pillars: ["pillar_hanoi"],
				dimensions: [
					{
						id: "center_height",
						title: "Center Height",
						minVal: 100,
						maxVal: 250,
						defaultVal: 190,
						step: 10,
						selectType: "range",
					},
					{
						id: "outer_height",
						title: "Outer Height",
						minVal: 100,
						maxVal: 250,
						defaultVal: 170,
						step: 10,
						selectType: "range",
					},
					{
						id: "door_width",
						title: "Door Width",
						minVal: 150,
						maxVal: 400,
						defaultVal: 150,
						step: 10,
						selectType: "range",
					},
					{
						id: "door_frame_width",
						title: "Door Frame Width",
						values: [5, 10, 15, 20],
						defaultVal: 10,
						selectType: "preset",
					},
					{
						id: "door_frame_thickness",
						title: "Door Frame Thickness",
						values: [5, 10, 15, 20],
						defaultVal: 10,
						selectType: "preset",
					},
					{
						id: "door_plank_width",
						title: "Door Plank Width",
						values: [5, 10, 12, 20],
						defaultVal: 20,
						selectType: "preset",
					},
				],
				modifiers: [],
			},
		],
		materials: [
			{
				id: "oak_whiteriver",
				type: "material",
				title: "Oak Whiteriver",
				thumbnail: "/textures/woodgrey/Wood_Oak_Whiteriver_Grey_Diffuse_1k.webp",
				textures: {
					map: "/textures/woodgrey/Wood_Oak_Whiteriver_Grey_Diffuse_1k.webp",
					normalMap: "/textures/woodgrey/Wood_Oak_Whiteriver_Grey_Normal_1k.webp",
					roughnessMap: "/textures/woodgrey/Wood_Oak_Whiteriver_Grey_Roughness_1k.webp",
				},
				options: {
					color: ["green"], //ids of colors
				},
				settings: {
					repeat: {
						x: 2,
						y: 2,
					},
					roughness: 8,
				},
			},
			{
				id: "oak_light",
				type: "material",
				title: "Oak Light",
				thumbnail: "/textures/wood/basecolor.webp",
				textures: {
					map: "/textures/wood/basecolor.webp",
					normalMap: "/textures/wood/normal.png",
					roughnessMap: "/textures/wood/roughness.webp",
				},
				options: {
					color: ["red", "blue"], //ids of colors
				},
				settings: {
					roughness: 6,
					repeat: {
						x: 1,
						y: 1,
					},
				},
			},
			{
				id: "brick_wall",
				type: "material",
				title: "Brick Wall",
				thumbnail: "/textures/brick/basecolor.webp",
				textures: {
					map: "/textures/brick/basecolor.webp",
					normalMap: "/textures/brick/normal.webp",
					roughnessMap: "/textures/brick/roughness.webp",
				},
				options: {
					color: [], //ids of colors
				},
				settings: {
					repeat: {
						x: 2,
						y: 2,
					},
					roughness: 2,
				},
			},
			{
				id: "concrete",
				type: "material",
				title: "Concrete",
				thumbnail: "/textures/concrete/Poliigon_ConcreteFloorPoured_7656_BaseColor.webp",
				textures: {
					map: "/textures/concrete/Poliigon_ConcreteFloorPoured_7656_BaseColor.webp",
					normalMap: "/textures/concrete/Poliigon_ConcreteFloorPoured_7656_Normal.webp",
					aoMap: "/textures/concrete/Poliigon_ConcreteFloorPoured_7656_Roughness.webp",
				},
				options: {
					color: [], //ids of colors
				},
				settings: {
					roughness: 2,
				},
			},
			{
				id: "oak_brown",
				type: "material",
				title: "Oak Brown",
				thumbnail: "/textures/beam/Wood078_1K_C.webp",
				textures: {
					map: "/textures/beam/Wood078_1K_C.jpg",
					normalMap: "/textures/beam/Wood078_1K_N.webp",
					roughnessMap: "/textures/beam/Wood078_1K_AO.jpg",
				},
				options: {
					color: ["red", "green"], //ids of colors
				},
				settings: {
					repeat: {
						x: 5,
						y: 5,
					},
					roughness: 5,
				},
			},
			{
				id: "worn_bronze",
				type: "material",
				title: "Worn Bronze",
				thumbnail: "/textures/worn_bronze/Poliigon_MetalBronzeWorn_7248_BaseColor.webp",
				textures: {
					map: "/textures/worn_bronze/Poliigon_MetalBronzeWorn_7248_BaseColor.webp",
					normalMap: "/textures/worn_bronze/Poliigon_MetalBronzeWorn_7248_Normal.webp",
					roughnessMap: "/textures/worn_bronze/Poliigon_MetalBronzeWorn_7248_Roughness.webp",
				},
				options: {
					color: [], //ids of colors
				},
				settings: {
					repeat: {
						x: 1,
						y: 1,
					},
					roughness: 2.5,
				},
			},
			{
				id: "light_metal",
				type: "material",
				title: "Light Metal",
				thumbnail: "/textures/metal/basecolor.webp",
				textures: {
					map: "/textures/metal/basecolor.webp",
					normalMap: "/textures/metal/normal.webp",
					roughnessMap: "/textures/metal/roughness.webp",
				},
				options: {
					color: [], //ids of colors
				},
				settings: {
					repeat: {
						x: 3,
						y: 3,
					},
					roughness: 0.7,
				},
			},
			{
				id: "heavy_metal",
				type: "material",
				title: "Heavy Metal",
				thumbnail: "/textures/heavy_metal/Poliigon_MetalPaintedMatte_7037_BaseColor.webp",
				textures: {
					map: "/textures/heavy_metal/Poliigon_MetalPaintedMatte_7037_BaseColor.webp",
					normalMap: "/textures/heavy_metal/Poliigon_MetalPaintedMatte_7037_Normal.png",
					roughnessMap: "/textures/heavy_metal/Poliigon_MetalPaintedMatte_7037_Roughness.webp",
				},
				options: {
					color: [], //ids of colors
				},
				settings: {
					repeat: {
						x: 3,
						y: 3,
					},
					roughness: 1.5,
				},
			},
		],
		colors: [
			{
				id: "red",
				title: "Red",
				hex: "red",
			},
			{
				id: "green",
				title: "Green",
				hex: "",
			},
			{
				id: "blue",
				title: "Blue",
				hex: "",
			},
		],
		shapes: [
			{
				id: "arc",
				title: "Arc",
				icon: "/icons/shape.svg",
			},
			{
				id: "straight",
				title: "Straight",
				icon: "/icons/shape.svg",
			},
			{
				id: "wave",
				title: "Wave",
				icon: "/icons/shape.svg",
			},
		],
		pillars: [
			{
				id: "pillar_stockholm",
				type: "pillar",
				title: "Stockholm",
				image: "/thumbnails/pillars/stockholm.jpg",
				materials: ["oak_light", "oak_whiteriver", "oak_brown"], //material id's
				dimensions: [
					{
						id: "pillar_width",
						title: "Pillar Width",
						minVal: 60,
						maxVal: 120,
						defaultVal: 60,
						step: 5,
						selectType: "range",
					},
					{
						id: "pillar_length",
						title: "Pillar Length",
						minVal: 60,
						maxVal: 120,
						defaultVal: 60,
						step: 5,
						selectType: "range",
					},
				],
				modifiers: ["mailbox"],
			},
			{
				id: "pillar_sanfrancisco",
				type: "pillar",
				title: "San Francisco",
				image: "/thumbnails/pillars/san_francisco.jpg",
				materials: ["brick_wall"], //material id's
				dimensions: [
					{
						id: "pillar_width",
						title: "Pillar Width",
						minVal: 60,
						maxVal: 120,
						defaultVal: 60,
						step: 5,
						selectType: "range",
					},
					{
						id: "pillar_length",
						title: "Pillar Length",
						minVal: 60,
						maxVal: 120,
						defaultVal: 60,
						step: 5,
						selectType: "range",
					},
				],
				modifiers: [],
			},
			{
				id: "pillar_tokyo",
				type: "pillar",
				title: "Tokyo",
				image: "",
				materials: ["oak_whiteriver"], //material id's
				dimensions: [
					{
						id: "pillar_width",
						title: "Pillar Width",
						minVal: 60,
						maxVal: 120,
						defaultVal: 80,
						step: 5,
						selectType: "range",
					},
					{
						id: "pillar_length",
						title: "Pillar Length",
						minVal: 60,
						maxVal: 120,
						defaultVal: 80,
						step: 5,
						selectType: "range",
					},
				],
			},
		],
		modifiers: [
			{
				id: "crown",
				title: "Crown",
				icon: () => (
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
						<path d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6l277.2 0c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z" />
					</svg>
				),
				location: "beam_vertical_top",
			},
			{
				id: "crown_2",
				title: "Crown 2",
				icon: () => (
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
						<path d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6l277.2 0c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z" />
					</svg>
				),
				location: "beam_vertical_top",
			},
			{
				id: "mailbox",
				title: "Mailbox",
				icon: () => (
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
						<path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48L48 64zM0 176L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-208L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
					</svg>
				),
				location: "pillar_front",
			},
			{
				id: "gate_support",
				title: "Gate Support",
				icon: () => (
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
						<path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
					</svg>
				),
				location: "gate_door_back",
			},
			{
				id: "pillar_foot",
				title: "Pillar Foot",
				icon: () => (
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
						<path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
					</svg>
				),
				location: "pillar_bottom",
				materials: ["concrete"],
				dimensions: [
					{
						id: "pillar_foot_height",
						title: "Pillar Foot Height",
						minVal: 10,
						maxVal: 90,
						defaultVal: 80,
						step: 5,
						selectType: "range",
					},
					{
						id: "pillar_foot_thickness",
						title: "Pillar Foot Tickness",
						minVal: 1,
						maxVal: 10,
						defaultVal: 5,
						step: 1,
						selectType: "range",
					},
				],
			},
		],
	},
	dashboard: {},
};
